export default __webpack_public_path__ + "static/media/instagram-ico.b79433a6.png";